import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getAllMyBids() {
  const data = await axiosInstance({
    url: "/bid/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getAllMyParticipation() {
  const data = await axiosInstance({
    url: "/bid/participate",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getBidByRound(formData: string) {
  const data = await axiosInstance({
    url: `/bid/round/${formData}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getBidLeaderBoard(formData: string) {
  const data = await axiosInstance({
    url: `/bid/leader/${formData}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const placeBid = async (formData: any) => {
  const data = await axiosInstance({
    url: "/bid",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useMyBids() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.myBids],
    queryFn: () => getAllMyBids(),
  });
  return data;
}

export function useMyParticipation() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.participation],
    queryFn: () => getAllMyParticipation(),
  });
  return data;
}

export function useGetBidByRound(formData: string) {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.allBidsByRound],
    queryFn: () => getBidByRound(formData),
  });
  return data;
}

export function useGetLeaderBoardByRound(formData: string) {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.bidLeaderBoard],
    queryFn: () => getBidLeaderBoard(formData),
  });
  return data;
}

export function usePlaceBid() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => placeBid(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.availableBids]);
      queryClient.invalidateQueries([queryKeys.myBids]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
